import React, { useState, useEffect } from "react";
// import { useSignIn } from 'react-auth-kit'
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AuthenticateService from "../auth/AuthenticateService";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AuthLayout from "./AuthLayout";

// import './Guest.css'
const Login = (props) => {
  const { http, setToken } = AuthenticateService();
  const [isLoging, setIsLoging] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const company = props.company;
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Welcome - Login";
  }, []);

  // console.log(company);

  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [logined, setLogined] = useState("");

  const onSubmit = (e) => {
    setError("");
    e.preventDefault();
    setIsLoging(true);

    if (formData.username === "" || formData.password === "") {
      setError("Username and password are required");
      return; // Return early if validation fails
    }
    setError("");
    // toast.info('Please Wait, Login in progress', {
    //     // autoClose: false, // Set autoClose to false to keep the toast visible until manually closed
    //   });

    http
      .post("/users/login", formData)

      .then((res) => {
        // console.log(res.status);

        if (res.status === 200) {
          setError("");
          setLogined(res.data.message);
          setToken(res.data.data.user, res.data.data.access_token);
        } else if (res.status === 203) {
          // console.log(res);
          sessionStorage.setItem("verify", JSON.stringify(res.data));
          navigate("otp");
        } else {
          // console.log(res.status);
          setError(res.message);
          setIsLoging(false);
        }
      })
      .catch((error) => {
        setError("Failed to Sign In : " + error?.response?.data?.message);
        setIsLoging(false);
      });
  };

  return (
    <AuthLayout company={company}>
      <ToastContainer />
      <div className="auth-heading">
        <h3 className="text-1000">Welcome back</h3>
        <p className="text-700">
          Sign in to {company?.company_name || "your account"} to continue
        </p>
      </div>

      {error && (
        <div className="alert alert-outline-danger d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-exclamation text-danger fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{error}</p>
        </div>
      )}
      {logined && (
        <div className="alert alert-outline-success d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-check text-success fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{logined}</p>
        </div>
      )}

      <form onSubmit={onSubmit}>
        <div className="auth-field">
          <label className="form-label" htmlFor="username">
            Username
          </label>
          <div className="form-icon-container">
            <input
              className="form-control form-icon-input"
              id="username"
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              type="text"
              placeholder="Enter your username"
              required
            />
            <span className="fas fa-user text-900 fs--1 form-icon"></span>
          </div>
        </div>
        <div className="auth-field">
          <label className="form-label" htmlFor="password">
            Password
          </label>
          <div className="form-icon-container position-relative">
            <input
              className="form-control form-icon-input"
              id="password"
              type={showPassword ? "text" : "password"}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              placeholder="Enter your password"
              required
            />
            <span className="fas fa-key text-900 fs--1 form-icon"></span>

            <button
              type="button"
              className="auth-toggle-visibility"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>
        <div className="row flex-between-center mb-4">
          <div className="col-auto">
            <div className="form-check mb-0">
              <input
                className="form-check-input"
                id="basic-checkbox"
                type="checkbox"
                checked="checked"
                readOnly
              />
              <label
                className="form-check-label mb-0 fs--1"
                htmlFor="basic-checkbox"
              >
                Remember me
              </label>
            </div>
          </div>
          <div className="col-auto">
            <Link className="fs--1 fw-semi-bold" to="/forget-password">
              Forgot Password?
            </Link>
          </div>
        </div>

        <button className="btn-auth-primary" disabled={isLoging}>
          {isLoging ? (
            <>
              <Spinner animation="border" size="sm" /> Signing in...
            </>
          ) : (
            <>
              Sign In <FontAwesomeIcon icon={faArrowRight} className="fs--1" />
            </>
          )}
        </button>
      </form>

      <div className="text-center mt-4">
        <span className="fs--1 text-700">Don't have an account? </span>
        {company?.reg_status == 1 ? (
          <Link to="/register" className="fs--1 fw-bold">
            Create an account
          </Link>
        ) : (
          <a
            href={company?.reg_url}
            target="_blank"
            rel="noopener noreferrer"
            className="fs--1 fw-bold"
          >
            Create an account
          </a>
        )}
      </div>
    </AuthLayout>
  );
  // }
};

export default Login;
